var site = site || {};

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function (selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " + extraClasses + "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function (id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.search = {
	init: function () {
		// Search toggle
		$('#searchToggle').on('click', function (e) {
			e.preventDefault();
			$('body').toggleClass('search-open');
			if ($('body').hasClass('search-open')) {
				$('#q').focus();
			}
			site.nav.close();
		});
	},
	close: function () {
		$('body').removeClass('search-open');
	}
}

site.extrasDropdown = {
	init: function () {

		$('#extras .readMore').on('click', function (e) {
			e.preventDefault();
			$(this).closest('.item').hasClass('open') ? $(this).closest('.item').removeClass('open') : $(this).closest('.item').addClass('open');

		});
	}

}


site.nav = {
	// Init navigation scripts
	init: function () {
		// Add expand link to mobile menu
		$('.children', '#mainmenu').prepend('<span class="expand"><i class="fa fa-angle-right"></i></span>');

		site.nav.bind();

		$('.selectedLevel1 > .expand', '#mainmenu').trigger('click');
		$('.selectedLevel2 > .expand', '#mainmenu').trigger('click');
		$('.selectedLevel3 > .expand', '#mainmenu').trigger('click');
	},
	bind: function () {
		// Mobile menu toggle
		$('#mainmenuToggle').click(function (e) {
			site.nav.mobileToggle();
			e.preventDefault();
		});

		// Expand in mobile menu
		$('.expand', '#mainmenu').on('click', function (e) {
			e.preventDefault();

			var $this = $(this);
			var $ul = $this.siblings('ul');
			var $i = $this.find('i');

			$ul.toggleClass('show');
			$this.next().toggleClass('down');
			$i.toggleClass('fa-angle-down');
			e.preventDefault();
		});
	},

	// Toggle mobile menu
	mobileToggle: function () {
		$('body').toggleClass('mainmenu-open');
		$(this).toggleClass('open');
	},

	// Append language to mobilemenu
	appendLanguage: function () {
		var $divisions = $('.menu', '#divisions');
		var $menu = $('ul.mmLevel1', '#mMenu');

		var $html = $('<li class="ele-language si level1"></li>');
		$divisions.find('li').each(function () {
			var $li = $(this).clone();
			$html.append($li.find('a'));
		});

		$menu.append($html);
	}
};

site.fontsize = {
	init: function () {
		$('#fontsize')
			.on('click', 'span', function (e) {
				e.preventDefault();

				var $a = $(this),
					$html = $('html');

				if ($a.hasClass('font__up')) {
					if (!$html.hasClass('font-big')) {
						$html.addClass('font-big');
						$.cookie('font-big', 'true', { expires: 1, path: '/' });
					}
				}
				else {
					if ($html.hasClass('font-big')) {
						$html.removeClass('font-big');
						$.cookie('font-big', 'false', { expires: 1, path: '/' });
					}
				}
			});
	},
	check: function () {
		const v = document.cookie.match('(^|;) ?font-big=([^;]*)(;|$)');
		const val =  v ? v[2] : null;
		if (val === 'true') {
			$('html').addClass('font-big');
		}
	}
};


// Run all the inits \o/
$(function () {
	site.fontsize.init();
    site.fontsize.check();
	site.nav.init();
	site.search.init();
	site.extrasDropdown.init();
	site.maxHeight.init('.item_description');
	site.owl.init('#reviews > ul', {
		loop: true,
		nav: true,
		navText: ["", ""],
		items: 1
	});


	// Responsive vimeo player
	//var $i = $('iframe', '#center');
	//if ($i.length > 0 && $i.attr('src').indexOf('player.vimeo.com') != -1) {
	//	$i.wrap('<div class="vimeoPlayer"></div>');
	//}

	// Responsive tables
	$('table', '#center').wrap('<div class="responsiveTable"></div>');

	// Touch login
	$('.login').bind('click', function (e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);

	$('body.frontpage .headlines .boxTitle')
		.nextUntil('body.frontpage .headlines .boxText')
		.andSelf().add('body.frontpage .headlines .boxText')
		.wrapAll("<div class='inner'></div>");

	$('body.frontpage .notices .boxTitle')
		.nextUntil('body.frontpage .notices .boxText')
		.andSelf().add('body.frontpage .notices .boxText')
		.wrapAll("<div class='inner'></div>");

	$('body.frontpage .events .boxTitle')
		.nextUntil('body.frontpage .events .boxText')
		.andSelf().add('body.frontpage .events .boxText')
		.wrapAll("<div class='inner'></div>");

	$('body.frontpage .video .boxTitle')
		.nextUntil('body.frontpage .video .boxText')
		.andSelf().add('body.frontpage .video .boxText')
		.wrapAll("<div class='inner'></div>");

	$('body.frontpage .box_galleryimage .boxTitle')
		.nextUntil('body.frontpage .box_galleryimage .boxText')
		.andSelf().add('body.frontpage .box_galleryimage .boxText')
		.wrapAll("<div class='inner'></div>");

	$('a', '#quicknav').each(function () {
		var str = window.location.href,
			href = this.href,
			re = new RegExp(href + '$', 'gi');

		if (href && str.match(re)) {
			$(this).addClass('active');
		}
	})

	$('a', '#color_boxes').each(function () {
		var str = window.location.href,
			href = this.href,
			re = new RegExp(href, 'gi');

		if (href && str.match(re)) {
			$(this).parent('li').addClass('selectedLevel1');
		}
	})

	$('#facebookLikeToggle').on('click', function (e) {
		e.preventDefault();

		var $this = $(this),
			$boxText = $this.parents('.boxText');

		$this.hide();
		$boxText.find('.fb-like').show();
	});
});
